"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const as = ['div', 'span'];
const displayValues = ['none', 'inline-grid', 'grid'];
const columnsValues = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const rowsValues = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
const flowValues = ['row', 'column', 'dense', 'row-dense', 'column-dense'];
const alignValues = ['start', 'center', 'end', 'baseline', 'stretch'];
const justifyValues = ['start', 'center', 'end', 'between'];
const gridPropDefs = {
    as: { type: 'enum', values: as, default: 'div' },
    asChild: index_js_1.asChildProp,
    display: {
        type: 'enum',
        className: 'rt-r-display',
        values: displayValues,
        default: undefined,
        responsive: true,
    },
    columns: {
        type: 'enum | string',
        className: 'rt-r-gtc',
        customProperties: ['--grid-template-columns'],
        values: columnsValues,
        parseValue: parseGridValue,
        default: undefined,
        responsive: true,
    },
    rows: {
        type: 'enum | string',
        className: 'rt-r-gtr',
        customProperties: ['--grid-template-rows'],
        values: rowsValues,
        parseValue: parseGridValue,
        default: undefined,
        responsive: true,
    },
    flow: {
        type: 'enum',
        className: 'rt-r-gaf',
        values: flowValues,
        default: undefined,
        responsive: true,
    },
    align: {
        type: 'enum',
        className: 'rt-r-ai',
        values: alignValues,
        default: undefined,
        responsive: true,
    },
    justify: {
        type: 'enum',
        className: 'rt-r-jc',
        values: justifyValues,
        parseValue: parseJustifyValue,
        default: undefined,
        responsive: true,
    },
    ...index_js_1.gapProps,
};
exports.gridPropDefs = gridPropDefs;
function parseGridValue(value) {
    if (gridPropDefs.columns.values.includes(value)) {
        return value;
    }
    return value?.match(/^\d+$/) ? `repeat(${value}, minmax(0, 1fr))` : value;
}
function parseJustifyValue(value) {
    return value === 'between' ? 'space-between' : value;
}
//# sourceMappingURL=grid.props.js.map